<template>
	<div class="chart-finance-panels-group">
		<chart-boxes-container :data="chartsData" :tabs="tabs" extra-class="single"/>
		<div class="finance-panel-group">
			<h3 class="finance-panel-group-title">{{ title }}</h3>
			<finance-panel-boxes-container :data="financePanelsData"/>
		</div>

	</div>
</template>

<script>
import ChartBoxesContainer from "@/components/containers/ChartBoxesContainer";
import FinancePanelBoxesContainer from "@/components/containers/FinancePanelBoxesContainer";

export default {
	name: "ChartPanelsGroup",
	props: ['financePanelsData', 'chartsData', 'tabs', 'title'],
	components: {
		ChartBoxesContainer,
		FinancePanelBoxesContainer
	}
}
</script>

<style scoped lang="scss">
.finance-panel-group-title {
	font-size: 20px;
}
	.chart-finance-panels-group {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 15px;
		&:last-child {
			margin-bottom: 0;
		}
		.chart-boxes-container {
			width: 45%;
		}
		.finance-panel-group {
			width: calc(55% - 30px);
		}

		@media($desktopM){
			.chart-boxes-container {
				width: 50%;
			}

			.finance-panel-group {
				width: calc(50% - 15px);
			}
		}

		@media($tabletL){
			flex-direction: column;
			.chart-boxes-container {
				width: 100%;
				margin-bottom: 30px;
			}
			.finance-panel-group {
				width: 100%;
				margin-top: 0;
			}
		}
	}
</style>